import { Fragment, useMemo } from 'react';

import {
  BANDS_DJS_TAXONOMY_KEY,
  getVendorWordCategory,
  SearchableVendorTaxonomyKey,
} from '@zola-helpers/client/dist/es/marketplace';
import { SeoContentView, SeoItemView } from '@zola/svc-marketplace-ts-types';

import { useSearchResultsPageContext } from '~/pages/couples/explore/components/SearchResults/contexts/SearchResultsPageContext';

import { getVendorTypeFAQ } from '../../../CategoryLandingPage/FaqSection/FaqSection';
import { BackendSeoContentBlock } from './BackendSeoContentBlock';

const BackendSeoBlockWithHead = () => {
  const { vendorSearch, seoContent } = useSearchResultsPageContext();
  const { selectedLocation, selectedTaxonomy } = vendorSearch;

  const hed = useMemo(() => {
    // Not ideal but we need to handle the special case of uppercase DJ
    const isBandDj = selectedTaxonomy?.key === BANDS_DJS_TAXONOMY_KEY;
    return `About wedding ${
      isBandDj
        ? 'bands & DJs'
        : getVendorWordCategory(selectedTaxonomy?.key || '').toLocaleLowerCase()
    } in ${selectedLocation?.label}`;
  }, [selectedLocation?.label, selectedTaxonomy?.key]);

  return <BackendSeoContentBlock hed={hed} seoContent={seoContent} />;
};

export const SeoContentBlock = () => {
  const { seoContent, vendorSearch } = useSearchResultsPageContext();

  if (seoContent) {
    return <BackendSeoBlockWithHead />;
  }

  // Special case for the all markets / one taxonomy
  if (vendorSearch.selectedLocation?.type === 'ALL_MARKETS' && vendorSearch.selectedTaxonomy?.key) {
    const vendorFaq = getVendorTypeFAQ(
      vendorSearch.selectedTaxonomy.key as SearchableVendorTaxonomyKey
    );
    const specialCaseContent: SeoContentView = {
      editorials: [] as SeoItemView[],
      faqs: vendorFaq.content.map(({ question, answer }) => {
        return {
          type: 'PARAGRAPH',
          heading: question,
          htmlContent: [answer],
          contentKey: 'ADJACENT_CITIES',
          children: [],
          subheading: null,
        };
      }),
    };

    return (
      <BackendSeoContentBlock
        hed={`About wedding ${getVendorWordCategory(
          vendorSearch.selectedTaxonomy?.key || ''
        ).toLocaleLowerCase()}`}
        seoContent={specialCaseContent}
      />
    );
  }

  return <Fragment />;
};
